// Format dollar values
export function dollarize(value, includeDecimals = true) {
  if (value == null || value === "" || value === ".") return "$0.00";

  // Ensure the value is a number
  const number = typeof value === "number" ? value : parseFloat(value);
  if (isNaN(number)) return "Invalid amount";

  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: includeDecimals ? 2 : 0,
    maximumFractionDigits: includeDecimals ? 2 : 0,
  }).format(includeDecimals ? number : Math.round(number));
}

// Undollarize a string
export function undollarize(dollarString) {
  if (typeof dollarString !== "string") return NaN;

  // Remove currency symbols, commas, and trim whitespace
  const numericString = dollarString.replace(/[^0-9.-]/g, "").trim();

  // Convert to number
  const number = parseFloat(numericString);

  return isNaN(number) ? NaN : number;
}
